import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import reducers from './redux/reducers';
import './index.css';
import App from './App';
import { loadDefaultState } from './redux/helpers/loadDefaulState';
import { getParams } from './redux/helpers/getParams';

import LanguageHandler from './components/language/LanguageHandler';
import { browserNotSupported } from './redux/helpers';

const urlLangugeCode = new URL(window.location.href).searchParams.get('lang');
const lang = new LanguageHandler(urlLangugeCode);

const store = createStore(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), applyMiddleware(thunk));
// preload layouts, images
const autofill = false;
let bookId = getParams('calendarId');
const context = getParams('context');

if (getParams('calendarId') === null) {
  bookId = '00';
} else {
  bookId = getParams('calendarId');
}

// get book type
const bookContext = context !== undefined && context !== null ? context : 'consumer';
const autofillByLoadTest = autofill;
if (!browserNotSupported()) {
  loadDefaultState(store, bookId, autofillByLoadTest, bookContext, lang);
}

ReactDOM.render(
  <Provider store={store}>
    <App lang={lang} />
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js